import React from "react";
import { Container, Card, ListGroup } from 'react-bootstrap';

const ARTICLES_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:8001').replace(/\/$/, '') + '/api/articles';


const Main_publications_En = () => {
    const publications = [
        {
            year: 2025,
            items: [
                {
                    title: "Petrakova V.S. Study of the Inverse SEIR-HCD Epidemiological Mean Field Problem.",
                    journal: "2025 21st International Asian School-Seminar on Optimization Problems of Complex Systems (OPCS).",
                    doi: "10.1109/OPCS67346.2025.11219390",
                    link: "https://doi.org/10.1109/OPCS67346.2025.11219390"
                },
                {
                    title: "Shaydurov V., Petrakova V. Correction of dynamic model parameters by observed data.",
                    journal: "2025, V. 46, P. 879\u2013887.",
                    doi: "10.1134/S1995080225600281",
                    link: "https://doi.org/10.1134/S1995080225600281"
                },
                {
                    title: "Krivorotko O.I., Kabanikhin S.I., Neverov A.V. Differential models of epidemics and scenarios of restrictive measures.",
                    journal: "Computational Mathematics and Mathematical Physics, 2025,",
                    volume: "V. 65, No. 6, pp. 946\u2013960.",
                    doi: "10.31857/S0044466925060081",
                    link: "https://doi.org/10.31857/S0044466925060081"
                },
                {
                    title: "Nesterova A.V., Denisova N.V., Minin S.M., Anashbaev Zh.Zh., Usov V.Yu. Determination of correction coefficients in the quantitative assessment of bone pathological foci by gamma-emission tomography.",
                    journal: "Computer Research and Modeling, 2025,",
                    volume: "V. 17, No. 4, pp. 677\u2013696.",
                    doi: "10.20537/2076-7633-2025-17-4-677-696",
                    link: "https://doi.org/10.20537/2076-7633-2025-17-4-677-696"
                },
                {
                    title: "Zvonareva T.A., Krivorotko O.I. Regularization of the numerical solution of the problem of reconstructing the initial condition for a nonlinear diffusion-logistic model.",
                    journal: "Siberian Electronic Mathematical Reports, 2025,",
                    volume: "V. 22, No. 1, pp. 874\u2013891.",
                    doi: "10.33048/semi.2025.22.055",
                    link: "https://doi.org/10.33048/semi.2025.22.055"
                },
                {
                    title: "Zvonareva T.A., Krivorotko O.I. Modeling of information spread within the mean field framework.",
                    journal: "Siberian Electronic Mathematical Reports, 2025,",
                    volume: "V. 22, No. 1, pp. 307\u2013325.",
                    doi: "10.33048/semi.2025.22.021",
                    link: "https://doi.org/10.33048/semi.2025.22.021"
                },
                {
                    title: "Petrakova V.S., Krivorotko O.I. The problems arising when the reconstructing of functional of the optimal control system describing the epidemiological process.",
                    journal: "Differential Equations and Dynamical Systems, 2025."
                },
                {
                    title: "Olga Krivorotko, Nikolay Zyatkov. Bayesian calibration and sensitivity analysis of ordinary differential equation models for Tuberculosis spread in the Russian Federation.",
                    journal: "Computational Mathematics and Modeling, 2025.",
                    doi: "10.1007/s10598-025-09656-6",
                    link: "https://doi.org/10.1007/s10598-025-09656-6"
                },
                {
                    title: "Petrakova V.S. Post-analysis of Covid-19 incidence data by the SSA method on the example of the Novosibirsk region.",
                    journal: "Russian Journal of Infection and Immunity, 2025."
                }
            ]
        },
    ];

    return (
        <Container style={{ padding: 0, margin: 0 }}>
            {publications.map((pubYear) => (
                <div key={pubYear.year} className="my-4">
                    <h3>{pubYear.year}</h3>
                    <ListGroup as="ol" variant="flush" className="p-0 m-0">
                        {pubYear.items.map((item, index) => (
                            <ListGroup.Item as="li" key={index} className="p-0 m-0">
                                <a href={item.link} style={{ textDecoration: 'none' }}>
                                    <Card className="pubcardcol" style={{ margin: 0, padding: 0 }}>
                                        <Card.Body>
                                            <Card.Title>
                                                <h5 align='left'>{item.title}</h5>
                                            </Card.Title>
                                            <Card.Text align='left'>
                                                {item.journal && <span>{item.journal} </span>}
                                                {item.volume && <span>{item.volume} </span>}
                                                {item.pages && <span>{item.pages} </span>}
                                                {item.details && <span>{item.details} </span>}
                                                {item.conference && <span>{item.conference} </span>}
                                                {item.doi && <span>DOI: {item.doi}</span>}
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </a>
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </div>
            ))}
        </Container>
    );
};

export default Main_publications_En;

